// extracted by mini-css-extract-plugin
module.exports =  {"subProposalsStatusBar":"subProposalsStatusBar__BY4Is","subProposalBlock":"subProposalBlock__ZG1Bx"};